import React from 'react';
import s from '../SipCalBtfWidget/SipCalBtfWidget.scss';

const SipCalBtfWidget = ({ isMobile }) => {
  const data = {
    qna: [
      {
        que: 'What is SIP?',
        ans: [
          "Systematic Investment Plans (SIPs) provide individuals with the chance to participate in mutual funds and the stock market, even if they don't have extensive market expertise or the ability to closely track it. By making consistent investments through SIPs, you can achieve your objectives even with a relatively small monthly contribution, say experts",
          'Through SIPs, investors can invest their funds into a mutual fund at regular, predetermined intervals, such as on a monthly or quarterly basis. This strategy allows for wealth accumulation through regular investments, irrespective of the invested amount, by harnessing the potential of compounding and rupee cost averaging.',
        ],
      },
      {
        que: 'What is a SIP Calculator?',
        ans: [
          'The SIP Calculator is a simple tool that helps you estimate the potential returns on your mutual fund investments made through regular, fixed installments.',
          'By utilizing this calculator, you can determine the potential wealth accumulation and anticipated returns for your monthly SIP investment. It provides an approximate estimation of the maturity amount for any of your monthly SIPs, calculated using an assumed annual return rate. The SIP calculator in no way offers any guaranteed returns, just an approximation based on assumptions. ',
          'It is important to note that the actual returns delivered by a mutual fund scheme can vary based on several factors. Additionally, the SIP calculator does not offer information regarding any applicable exit load or expense ratio.',
        ],
      },
      {
        que: 'How does the SIP Calculator work?',
        ans: [`The SIP Calculator works on the simple formula provided below:`],
      },
      {
        que: 'How to use the SIP Calculator?',
        ans: [
          'Using the SIP Calculator is very simple. You need to input just three values to get the expected value of your maturity corpus. These are; your expected monthly contribution, expected rate of return and the number of years for which you plan to make the investment.',
          'By utilizing this calculator, you can determine the potential wealth accumulation and anticipated returns for your monthly SIP investment. It provides an approximate estimation of the maturity amount for any of your monthly SIPs, calculated using an assumed annual return rate. The SIP calculator in no way offers any guaranteed returns, just an approximation based on assumptions. ',
          'You can also choose the ‘Lumpsum’ option to arrive at the end corpus based on your expected rate of return and period of investment.',
        ],
      },
      {
        que: 'Advantages of SIP Calculator',
        ans: [
          'Using a simple tool such as the SIP Calculator will help you make a more informed decision on your investments. While it’s imperative to understand that the calculated corpus figure is based on your own assumption of expected returns, it still serves as an effective way to plan your finances and understand how regular and systematic investments can help you achieve your short and long term goals.',
        ],
      },
    ],
  };
  return (
    <>
      <div className={s.commonBlockWrap}>
        <div className={`${s.common_block} ${isMobile ? '' : 'mb40'}`}>
          {data && data?.description && <p>{data?.description}</p>}
          {data &&
            data.qna.map &&
            Array.isArray(data.qna) &&
            data.qna.length > 0 &&
            data.qna.map((desc, index) => (
              <>
                {desc.que && <h3>{desc.que}</h3>}
                {index !== 2 &&
                  desc.ans && (
                    <ul>
                      {desc.ans && desc.ans.map(answer => <li>{answer}</li>)}
                    </ul>
                  )}
                {index === 2 &&
                  desc.ans && (
                    <ul>
                      <li>
                        The SIP Calculator works on the simple formula provided
                        below:
                      </li>
                      <p> FV = P [ (1+i)^n-1 ] * (1+i)/i </p>
                      <p> Where: </p>
                      <p>
                        <li>
                          FV is the Future Value or the amount you can expect to
                          get on maturity{' '}
                        </li>
                      </p>
                      <p>
                        <li>
                          P is the Principal amount that you are investing
                          through the SIP
                        </li>
                      </p>
                      <p>
                        <li>I is the Compounded rate of return </li>
                      </p>
                      <p>
                        <li>
                          N is the duration (months) for which you have made
                          investments
                        </li>
                      </p>
                      <p>
                        <li>
                          R is the expected rate of return from your SIP
                          investment,
                        </li>
                      </p>

                      <li>
                        To give you an example, let’s say that you invest Rs
                        15,000 per month in SIP for a period of 15 years. You
                        are expecting a rate of return of 12%. Then your
                        expected corpus would be Rs 75.68 lakh.
                      </li>
                      <li>
                        It is important to understand that the rate of return
                        you assume will determine the expected corpus value.
                        Market conditions vary and the actual rate of return may
                        be different.
                      </li>
                    </ul>
                  )}
              </>
            ))}
        </div>
      </div>
    </>
  );
};

export default SipCalBtfWidget;
